import { DataTable } from "@/components/data-table";
import { Cotizacion } from "@/shared/types/cotizacion";
import { Moneda } from "@/shared/types/moneda";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { Button, Stack, StackProps, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { formatNumber } from "@/shared/formats";

export interface MonetizacionTablesProps extends StackProps {
    monedas: Moneda[],
    metodos: TransferenciaMetodo[],
    cotizacion: Cotizacion,

    onEditMonedasClick?: () => any,
    onEditCotizacionClick?: () => any,
    onEditMetodosClick?: () => any
}

export default function MonetizacionTables({
    monedas,
    metodos,
    cotizacion,
    onEditCotizacionClick,
    onEditMetodosClick,
    onEditMonedasClick,
    ...props
}: MonetizacionTablesProps) {
    const monedaBase = monedas.find(m => m.monedaBase)!;
    const monedasWithCotizacion = monedas.map(m => ({
        ...m,
        monedaBaseRelacion: cotizacion.cotizacionItems.find(ci => ci.monedaId === m.id)?.monedaBaseRelacion
    }))

    return <Stack gap={3} {...props}>
        <Stack gap={1}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                <Typography variant="h6">Monedas</Typography>
                <Stack direction={"row"} alignItems={"center"} gap={3}>
                    <Button size="small" startIcon={<EditIcon />} onClick={onEditMonedasClick}>Editar</Button>
                    <Button variant="outlined" size="small" startIcon={<AttachMoneyIcon />} onClick={onEditCotizacionClick}>Cotización</Button>
                </Stack>
            </Stack>
            <DataTable flex={1}>
                <DataTable.Content
                    rows={monedasWithCotizacion}
                    columns={[
                        { header: "Nombre", render: row => row.nombre },
                        { header: "Simbolo", render: row => row.simbolo, align: "center" },
                        {
                            header: "Estado", render: row => row.monedaBase ? <Typography color="text.secondary" variant="inherit">Principal</Typography> :
                                row.hidden ? "Oculto" : "Visible", align: "center"
                        },
                        {
                            header: `Valor (en ${monedaBase?.simbolo})`,
                            render: row => row.monedaBase ?
                                <Typography color="text.secondary" variant="inherit">Principal</Typography> :
                                formatNumber(row?.monedaBaseRelacion ?? 1, 10),
                            align: "right"
                        },
                        {
                            header: `Valor (por 1${monedaBase?.simbolo})`,
                            render: row => row.monedaBase ?
                                <Typography color="text.secondary" variant="inherit">Principal</Typography> :
                                formatNumber(1 / (row?.monedaBaseRelacion ?? 1), 10),
                            align: "right"
                        }
                    ]}
                />
            </DataTable>
        </Stack>
        <Stack gap={1}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                <Typography variant="h6">Formas de Pago</Typography>
                <Button size="small" startIcon={<EditIcon />} onClick={onEditMetodosClick}>Editar</Button>
            </Stack>
            <DataTable flex={1}>
                <DataTable.Content
                    rows={metodos}
                    columns={[
                        { header: "Nombre", render: row => row.nombre },
                        { header: "Estado", render: row => row.hidden ? "Oculto" : "Visible", align: "center", width: "auto" },
                    ]}
                />
            </DataTable>
        </Stack>
    </Stack>
}